import { useEffect, useState } from "react";
import api from "@/lib/api";

function PlayIcon() {
  return (
    <svg viewBox="0 0 512 512" className="h-6 w-6" aria-hidden="true">
      <path fill="#00d2ff" d="M48 32 300 256 48 480c-9-5-16-16-16-30V62c0-14 7-25 16-30z" />
      <path fill="#00f076" d="M48 32c6-3 13-3 21 1l248 141-59 59z" />
      <path fill="#ff3a44" d="M258 315l59 59L69 479c-8 4-15 4-21 1z" />
      <path fill="#ffce00" d="M317 173l73 41c22 12 22 42 0 54l-73 41-59-59z" />
    </svg>
  );
}

function AppleIcon() {
  return (
    <svg viewBox="0 0 384 512" className="h-6 w-6 fill-white" aria-hidden="true">
      <path d="M318 268c-1-59 48-87 50-89-27-40-70-45-85-46-36-4-70 21-89 21-18 0-46-21-76-20-39 1-75 23-95 57-40 70-10 173 29 230 19 27 42 58 72 57 29-1 40-19 75-19s45 19 76 18c31-1 51-28 70-56 22-32 31-63 31-64-1-1-60-23-60-90zM260 74c16-20 27-47 24-74-23 1-51 15-68 34-15 17-28 45-24 71 25 2 51-13 68-31z" />
    </svg>
  );
}

function StoreBadge({ icon, top, bottom, comingSoon, testid, href }) {
  const inner = (
    <span className="flex items-center gap-3 w-full">
      {icon}
      <span className="flex flex-col items-start leading-tight">
        <span className="text-[10px] uppercase tracking-wide text-slate-400">{top}</span>
        <span className="text-sm font-semibold text-white">{bottom}</span>
      </span>
      {comingSoon && <span className="ml-auto text-[9px] font-bold uppercase tracking-wide text-gold bg-gold/10 border border-gold/30 rounded px-1.5 py-0.5">Soon</span>}
    </span>
  );
  const base = "flex items-center gap-3 h-14 px-4 rounded-xl border border-white/15 bg-white/5 min-w-[176px]";
  if (comingSoon) {
    return <span data-testid={testid} aria-disabled="true" className={`${base} opacity-70 cursor-not-allowed`}>{inner}</span>;
  }
  return <a href={href} target="_blank" rel="noopener noreferrer" data-testid={testid} className={`${base} hover:border-gold/50 transition-colors`}>{inner}</a>;
}

export function AppBadges() {
  const [playUrl, setPlayUrl] = useState("");

  useEffect(() => {
    api.get("/app-config").then((r) => setPlayUrl(r.data?.play_store_url || "")).catch(() => {});
  }, []);

  return (
    <div className="mt-7" data-testid="app-download">
      <p className="text-xs uppercase tracking-wider text-gold font-semibold mb-3">Get the KRV Prime App</p>
      <div className="flex flex-wrap gap-3">
        <StoreBadge
          testid="badge-play"
          icon={<PlayIcon />}
          top={playUrl ? "Get it on" : "Coming soon on"}
          bottom="Google Play"
          comingSoon={!playUrl}
          href={playUrl || undefined}
        />
        <StoreBadge testid="badge-appstore" icon={<AppleIcon />} top="Coming soon on the" bottom="App Store" comingSoon />
      </div>
      <p className="mt-3 text-xs text-slate-500">Get the native Android app on Google Play — iOS app coming soon.</p>
    </div>
  );
}
